

"use client";

import React from 'react';
import { motion } from 'framer-motion';
import { PALETTE } from '@/app/lib/colorPallete';
import { LogOut, LifeBuoy, Settings } from 'lucide-react';
import { useAuth } from '../context/AuthContext';
import { ProfileDropdownProps } from '../types/types';
const DropdownButton = ({
  onClick,
  children,
  className = '',
}: {
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
}) => (
  <button
    onClick={onClick}
    className={`w-full flex items-center gap-3 px-3 py-2 text-sm rounded-md transition-colors duration-200 ${className}`}
  >
    {children}
  </button>
);

const ProfileDropdown: React.FC<ProfileDropdownProps> = ({ user, logout, onClose }) => {

  const { openSettingsModal } = useAuth();

  const handleLogout = async () => {
    onClose(); // Close the dropdown immediately
    await logout();
  };


  const handleSettingsClick = () => {
    onClose(); // Close the dropdown
    openSettingsModal(); // Open the settings modal
  };

  const paperTextureStyle = {
    backgroundImage: `url('data:image/svg+xml,%3Csvg width="60" height="60" viewBox="0 0 60 60" xmlns="http://www.w3.org/2000/svg"%3E%3Cg fill="none" fill-rule="evenodd"%3E%3Cg fill="%23626F47" fill-opacity="0.04"%3E%3Cpath d="M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z"/%3E%3C/g%3E%3C/g%3E%3C/svg%3E')`,
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 10, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      exit={{ opacity: 0, y: 10, scale: 0.95 }}
      transition={{ duration: 0.2, ease: 'easeOut' }}
      className="absolute top-full right-0 mt-3 w-72 origin-top-right rounded-xl shadow-2xl z-50"
      style={{ 
        backgroundColor: PALETTE.cream, 
        border: `1px solid ${PALETTE.midGreen}40`,
        color: PALETTE.darkGreen,
        ...paperTextureStyle
      }}
    >
      <div className="p-4 border-b" style={{ borderColor: `${PALETTE.midGreen}40` }}>
        <p className="font-serif text-lg font-semibold truncate">{user.name}</p>
        <p className="text-sm text-stone-500 truncate">{user.email}</p>
      </div>
      
       <div className="p-2 space-y-1">
        {}
        <DropdownButton onClick={handleSettingsClick} className="hover:bg-stone-200">
            <Settings size={18} className="opacity-70"/>
            <span>Settings</span>
        </DropdownButton>

        <DropdownButton className="hover:bg-stone-200">
            <LifeBuoy size={18} className="opacity-70"/>
            <span>Support</span>
        </DropdownButton>
        
        <div className="border-t my-1 mx-2" style={{ borderColor: `${PALETTE.midGreen}40` }} />

        <DropdownButton
          onClick={handleLogout}
          className="text-red-600 hover:bg-red-50 font-semibold"
        >
          <LogOut size={18} />
          <span>Logout</span>
        </DropdownButton>
      </div>
    </motion.div>
  );
};

export default ProfileDropdown;